import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.title',
    defaultMessage: 'Book meeting',
  },
  meetingName: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.meetingName',
    defaultMessage: 'Meeting name',
  },
  startsAt: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.startsAt',
    defaultMessage: 'Starts at',
  },
  endsAt: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.endsAt',
    defaultMessage: 'Ends at',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.loading',
    defaultMessage: 'Loading...',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.submit',
    defaultMessage: 'Create',
  },
  host: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.host',
    defaultMessage: 'Host',
  },
  remove: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.remove',
    defaultMessage: 'Remove',
  },
  name: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.email',
    defaultMessage: 'Email',
  },
  addParticipant: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.addParticipant',
    defaultMessage: 'Add participant',
  },
  meetingBooked: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.meetingBooked',
    defaultMessage: 'Meeting booked',
  },
  meetingStartError: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.meetingStartError',
    defaultMessage: 'Meeting must start in the future',
  },
  meetingStartLargerThanMeetingEndError: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.meetingStartLargerThanMeetingEndError',
    defaultMessage: 'Meeting start cant be after end',
  },
  participantsError: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeetingModal.participantsError',
    defaultMessage: 'There must be at least two participants',
  },
})